import React, {useEffect} from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const DefineServiceParameter = (props) => {

    const {
        editor,
        clickedEdit,
        defineServiceParam,
        setDefineServiceParam,
        connectedService,
        setConnectedService,
        paramType,
        setParamType,
        requestParam,
        setRequestParam
    } = props;

    const handleDefineServiceParam = () => {
        setDefineServiceParam(!defineServiceParam);
    }

    const [servicesNames, setServicesNames] = React.useState(['none']);
    const paramTypes = ['headers', 'bodyParams', 'queryParams'];
    const [requestParams, setRequestParams] = React.useState(['none']);

    useEffect( () => {
        if(clickedEdit === true){
            const selected = editor.getSelected();
            const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
            const projectServices = JSON.parse(localStorage.getItem('data'))[selectedProject].services[0] ? JSON.parse(localStorage.getItem('data'))[selectedProject].services[0].services_requests : undefined;
            if(projectServices){
                setServicesNames([...projectServices.map( service => service.name), 'none' ]);
            }

            if(selected.attributes.attributes['service-name'] !== undefined){
              setConnectedService(selected.attributes.attributes['service-name']);
              setDefineServiceParam(true);
            }
            else{
              setConnectedService('none');
            }

            if(selected.attributes.attributes['type-param'] !== undefined){
              setParamType(selected.attributes.attributes['type-param']);
              setDefineServiceParam(true);
            }
            else{
              setParamType('headers');
            }

            if(selected.attributes.attributes['request-param'] !== undefined){
              setRequestParam(selected.attributes.attributes['request-param']);
              setDefineServiceParam(true);
            }
            else{
              setRequestParam('none');
            }

            if( selected.attributes.attributes['request-param'] === undefined && 
                selected.attributes.attributes['type-param'] === undefined &&
                selected.attributes.attributes['service-name'] === undefined
            ){
              setDefineServiceParam(false);
            }
        }
    },[clickedEdit])

    useEffect( () => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
        if(selectedProject > -1){
            const projectServices = JSON.parse(localStorage.getItem('data'))[selectedProject].services[0] ? JSON.parse(localStorage.getItem('data'))[selectedProject].services[0].services_requests : undefined;
            if(projectServices){
                const selectedService = projectServices.filter( service => service.name === connectedService);
                if(selectedService.length > 0){
                    if(paramType === 'headers'){
                        setRequestParams([...selectedService[0].headers.map(header => header[0]), 'none']);
                        if(selectedService[0].headers.length > 0 && selectedService[0].headers.map( header => header[0]).includes(requestParam) === false){
                            setRequestParam(selectedService[0].headers[0][0]);
                        }
                        else if (selectedService[0].headers.length === 0){
                            setRequestParam('none');
                        }
                    }
                    else if(paramType === 'bodyParams'){
                        setRequestParams([...selectedService[0].body_par.map(bodyPar => bodyPar[0]), 'none']);
                        if(selectedService[0].body_par.length > 0 && selectedService[0].body_par.map( bodyPar => bodyPar[0]).includes(requestParam) === false){
                            setRequestParam(selectedService[0].body_par[0][0]);
                        }
                        else if( selectedService[0].body_par.length === 0){
                            setRequestParam('none');
                        }
                    }
                    else if(paramType === 'queryParams'){
                        setRequestParams([...selectedService[0].query_par.map(queryPar => queryPar[0]), 'none']);
                        if(selectedService[0].query_par.length > 0 && selectedService[0].query_par.map( queryPar => queryPar[0]).includes(requestParam) === false){
                            setRequestParam(selectedService[0].query_par[0][0]);
                        }
                        else if( selectedService[0].query_par.length === 0){
                            setRequestParam('none');
                        }
                    }
                }
            }
        }

    },[paramType,connectedService])


    const selectService = (option) => {
        setConnectedService(option);
    }

    const selectParamType = (option) => {
        setParamType(option);
    }

    const selectRequestParam = (option) => {
        setRequestParam(option);
    }

    return(
        <>  
            <div className={clsx('spacingTopDiv2','teamSelector')}>
                <span onClick={handleDefineServiceParam} aria-hidden="true" className={clsx('teamSelector')}>
                    <Checkbox  checked={defineServiceParam} style={{color: '#0c4d82'}} inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                    <span className={clsx('boldBlue')}> Define as service parameter </span>
                    { defineServiceParam === true &&
                    <>
                        :<span style={{display: 'inline-block', marginLeft: '1vw' }}/>    
                    </>
                    }
                </span>
                { defineServiceParam === true &&
                    <>
                        <DropdownMechanism
                            target = {connectedService}
                            targets={servicesNames}
                            selectTarget={selectService}
                        />
                        { connectedService !== 'none' &&
                            <span>
                                &nbsp;&nbsp;
                                <DropdownMechanism
                                    target = {paramType}
                                    targets={paramTypes}
                                    selectTarget={selectParamType}
                                />
                                &nbsp;&nbsp;
                                <DropdownMechanism
                                    target = {requestParam}
                                    targets={requestParams}
                                    selectTarget={selectRequestParam}
                                />
                            </span>
                        }
                    </>
                }
            </div> 
            <span
                className={clsx('MuiFormHelperText-root', 'Mui-error')}
                style={
                    defineServiceParam === true && ( connectedService === 'none' || requestParam === 'none' )
                    ? { display: 'inherit' }
                    : { display: 'none' }
                }
            >   
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {connectedService === 'none' ? 'selected service none' : (
                    requestParam === 'none' && 'selected param none' 
                )}
            </span>

        </>
    )

}

export default  DefineServiceParameter;